<div class="container">
    <h3>Déconnexion en cours ...</h3>
</div>
